(() => {
  const KEY = "rj_wishlist_v1";

  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); }
    catch(e){ return []; }
  };

  const write = (arr) => localStorage.setItem(KEY, JSON.stringify(arr));
  const has = (h) => read().includes(h);

  const readFromUrl = () => {
    const raw = new URLSearchParams(location.search).get("w");
    if (!raw) return null;
    return raw
      .split(",")
      .map(s => decodeURIComponent(s.trim()))
      .filter(Boolean);
  };

  const buildShareUrl = (handles) => {
    const u = new URL(location.origin + location.pathname);
    u.searchParams.set("w", handles.map(h => encodeURIComponent(h)).join(","));
    return u.toString();
  };

  let currentHandles = [];
  let shareBound = false;

  const refreshShareUI = () => {
    const shareBtn = document.getElementById("rjShareBtn");
    if (!shareBtn) return;

    if (!shareBound) {
      shareBound = true;
      shareBtn.addEventListener("click", async () => {
        const url = buildShareUrl(currentHandles);

        try {
          if (navigator.share) {
            await navigator.share({ title: "Favoritos", text: "Minha lista de favoritos", url });
            return;
          }
        } catch (e) {}

        try {
          await navigator.clipboard.writeText(url);
          const old = shareBtn.textContent;
          shareBtn.textContent = "Link copiado";
          setTimeout(() => (shareBtn.textContent = old), 1400);
        } catch (e) {
          window.prompt("Copie o link:", url);
        }
      });
    }
  };



  const canTrackMeta = () => {
    const cp = window.Shopify?.customerPrivacy;
    try { return !!cp?.marketingAllowed?.(); } catch(e){ return false; }
  };

  const fire = (handle) => {
    if (window.fbq && canTrackMeta()) {
      fbq("track", "AddToWishlist", { content_ids: [handle], content_type: "product" });
    }
  };

  const money = (cents) => {
    if (typeof cents !== "number") return "";
    return (cents / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  };

  const syncButtons = () => {
    document.querySelectorAll("[data-wishlist]").forEach(b => {
      b.classList.toggle("active", has(b.dataset.handle));
    });
  };

  const fetchProduct = async (handle) => {
    const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: "same-origin" });
    if (!res.ok) throw new Error("fetch_failed");
    return res.json();
  };

  const renderEmpty = (mount, msg) => {
    mount.innerHTML = `
      <div class="rj-wishlist-empty">
        <strong>Você ainda não favoritou nenhuma joia.</strong>
        <div style="height:8px"></div>
        <a class="rj-wishlist-cta" href="/collections/all">Ver produtos</a>
      </div>
    `;
  };

  const renderGrid = (mount, products) => {
    const cards = products.map(p => {
      const img = (p.images && p.images[0]) ? p.images[0] : "";
      const url = p.url || `/products/${p.handle}`;
      const price = money(p.price);

      return `
        <a class="rj-wishlist-card" href="${url}">
          <div class="rj-wishlist-media">
            ${img ? `<img src="${img}" alt="${(p.title || "").replace(/"/g, "&quot;")}" loading="lazy">` : ""}
          </div>
          <div class="rj-wishlist-meta">
            <div class="rj-wishlist-name">${p.title || ""}</div>
            <div class="rj-wishlist-price">${price}</div>
          </div>
        </a>
      `;
    }).join("");

    mount.innerHTML = `<div class="rj-wishlist-grid">${cards}</div>`;
  };

  const renderWishlistPage = async () => {
    const root = document.querySelector("[data-wishlist-root]");
    if (!root) return;

    const mount = root.querySelector("[data-wishlist-page]");
    if (!mount) return;

    const fromUrl = readFromUrl();
    const handles = (fromUrl && fromUrl.length) ? fromUrl : read();
    currentHandles = handles;
    refreshShareUI();


    mount.innerHTML = `<div class="rj-wishlist-loading">Carregando...</div>`;

    const out = [];
    for (const h of handles) {
      try { out.push(await fetchProduct(h)); }
      catch(e){ /* ignora */ }
    }

    if (!out.length) { renderEmpty(mount); return; }
    renderGrid(mount, out);
  };

  document.addEventListener("click", (e) => {
    const b = e.target.closest("[data-wishlist]");
    if (!b) return;

    const h = b.dataset.handle;
    let arr = read();

    if (arr.includes(h)) arr = arr.filter(x => x !== h);
    else { arr.push(h); fire(h); }

    write(arr);
    syncButtons();
    renderWishlistPage();
  });

  document.addEventListener("DOMContentLoaded", () => {
    syncButtons();
    renderWishlistPage();
  });
const updateHeaderCount = () => {
  const el = document.querySelector(".rj-wl-count");
  if (!el) return;
  const arr = read();
  el.textContent = arr.length;
  el.style.display = arr.length ? "flex" : "none";
};

document.addEventListener("DOMContentLoaded", updateHeaderCount);

document.addEventListener("click", (e) => {
  if (e.target.closest("[data-wishlist]")) {
    setTimeout(updateHeaderCount, 10);
  }
});


})();
